import styled from 'styled-components';

export interface IconButtonProps {
    disabled?: boolean;
    $width?: string | number;
    $height?: string | number;
    $hoverColour?: string;
};

export const IconButton = styled.button<IconButtonProps>`
    padding: 0;
    margin: 0;
    border: none;
    background: none;

    /* Styles to position loading spinner */
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    // Stop iOS showing icons in blue
    color: inherit;

    ${({ disabled }) => `cursor: ${disabled ? 'not-allowed' : 'pointer'};`}
    ${({ $width }) => $width ? `width: ${typeof $width === 'number' ? `${$width}px` : $width};` : ''}
    ${({ $height }) => $height ? `height: ${typeof $height === 'number' || !isNaN(parseInt($height)) ? `${$height}px` : $height};` : ''}
    ${({ $hoverColour }) => $hoverColour ? `
        @media (hover: hover) {
            :hover {
                color: ${$hoverColour};
            }
        }
    ` : ''}
`;

IconButton.displayName = 'IconButton';

export interface IconImageProps {
    height?: string | number;
    width?: string | number;
    $maxHeight?: string;
    $maxWidth?: string;
    $hoverColour?: string;
    $disabled?: boolean;
};

export const IconImage = styled.img<IconImageProps>`
    ${({ $disabled }) => ($disabled ? 'opacity: 0.2;' : '')}
    ${({ height, width, $maxHeight, $maxWidth }) => {
        if ($maxHeight || $maxWidth) {
            return `${$maxHeight ? `max-height: ${$maxHeight};` : ''} ${
                $maxWidth ? `max-width: ${$maxWidth};` : ''
            } width: ${width || 'auto'}; height: ${height || 'auto'};`;
        } else if (height && !width) {
            return `width: auto;`;
        } else if (width && !height) {
            return `height: auto;`;
        } else if (!width && !height) {
            return `width: 30px; height: auto;`;
        }
    }}
    ${({ $hoverColour }) => $hoverColour ? `
        @media (hover: hover) {
            :hover {
                color: ${$hoverColour};
            }
        }
    ` : ''}
`;

IconImage.displayName = 'IconImage';
